<template>
  <div class="container">
    <img class="sports-hall-button" src="../assets/img/clubroom_btn.png" alt="部室棟">
    <img class="back-button" src="../assets/img/arrow.png" alt="戻る" @click="moveToB10w">
  </div>
</template>

<script>
  export default {
    name: "ClubRoom",
    methods: {
      moveToB10w() {
        this.$emit("play-sound", "audio/vrschool_se_select.mp3");
        this.$router.push("/corridor/b10w");
      }
    }
  }
</script>

<style scoped>

  .container {
    height: 100%;
    background: url("../assets/img/clubroom_bg.png") no-repeat fixed center;
    background-size: contain;
  }

  .sports-hall-button {
    position: absolute;
    left: 41%;
    top: 32%;
    width: 20%;
    animation: float 3s ease-in-out infinite;
  }

  .back-button {
    position: absolute;
    left: 46%;
    bottom: 8%;
    width: 10%;
    cursor: pointer;
    animation: move-back-arrow 3s ease-in-out infinite;
  }

  @keyframes float {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(16px);
    }
    100% {
      transform: translateY(0px);
    }
  }

  @keyframes move-back-arrow {
    0% {
      transform: translateY(16px) rotateX(180deg);
    }
    50% {
      transform: translateY(0px) rotateX(180deg);
    }
    100% {
      transform: translateY(16px) rotateX(180deg);
    }
  }

</style>